import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import Button from "components/button";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getUserListOptions
} from "../../../../redux/user/userState";
import { 
	loginAsUser
} from "../../../../redux/auth/authState";
import { useForm } from 'antd/lib/form/Form';
import { displayIcon } from "variables/icons";

const ActAsUserForm = () => {
	
  	const [form] = useForm();
	const dispatch = useDispatch();

	const userList = useSelector((state) => state.user.userListOptions.items);

	const handleUserSearch = (value) => {
		if (!value || value.length < 3) return;
		dispatch(getUserListOptions({actAsUserName: value, asOptions: 1}));
	};
    
  	const onSubmit = (formData) => {	
    	try {  
			dispatch(loginAsUser(formData));
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-[400px] h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
				<FormItem className="font-medium mb-4"
					name="user_id"
					label="Act as User"
				>
					<Select id="user_id"
						className="input-field"
						showSearch
						allowClear={true}
						filterOption={false}
						options={userList}
						onSearch={handleUserSearch}
                  	/>
				</FormItem>	  
				<FormItem className="font-medium mb-4"
					name="password"
					label="Your user Password"
				>
					<Input.Password id="password"
						className="input-field"
						visibilityToggle={true}
					/>
				</FormItem>	
				<div className="w-full flex gap-4 justify-end text-right my-3">
					<Button 
						type="submit" 
						className="crud-button btn-small"
					>
						{displayIcon('User', 'icon-item')}
						Login As
					</Button>		
				</div> 
	 					 			
	 		</Form>	 	
	 	</Card>
  	);
};

export default ActAsUserForm;
